import { IoIosEye } from "react-icons/io";
interface IProps {
  id: string;
  testId?: string;
  cb: (item: any) => void;
  row: any;
  // cell?: any;
}
const Eye = ({ id, testId, cb, row }: IProps) => (
  <button
    className="w-full border-none bg-transparent text-center"
    data-testid={testId}
    id={id}
    style={{ width: "20%", textAlign: "center", cursor: "pointer" }}
    onClick={() => {
      cb(row.original);
    }}
  >
    <IoIosEye size={25} className="text-purple-900" />
  </button>
);

export default Eye;
